<template>
  <div>
    <div class="setting">
      <div class="head-topbar lite-page-top linebottom sticky">
        <div class="topbar-left" @click="$router.go(-1)"><i class="icon-arrow-left"></i></div>
        <div class="topbar-main"><h4>纪念馆设置</h4></div>
      </div>
      <div>
        <div class="settingPage" style="padding: 0px;">
          <div @click="goto('/jnt/modify/'+id)" class="setting-item" style="padding-top: 5px;">
            <a class="item-cell"
              ><div class="item-cell__bd">修改资料</div>
              <div class="item-cell__ft ft-line"></div
            ></a>
          </div>
          <div @click="goto('/jnt/background/1/'+id)" class="setting-item">
            <a class="item-cell"
              ><div class="item-cell__bd">更换纪念堂背景</div>
              <div class="item-cell__ft ft-line"></div
            ></a>
          </div>
          <div class="setting-item" @click="goto('/jnt/background/2/'+id)">
            <a class="item-cell"
              ><div class="item-cell__bd">更换墓园背景</div>
              <div class="item-cell__ft ft-line"></div
            ></a>
          </div>
          <div class="setting-item" @click="goto('/jnt/music/'+id)">
            <a class="item-cell"
              ><div class="item-cell__bd">更换音乐</div>
              <div class="item-cell__ft ft-line"></div
            ></a>
          </div>
          <div class="setting-item">
            <a class="item-cell"
              ><div class="item-cell__bd">是否公开纪念馆</div>
              <div class="item-cell__ft ">
                <van-switch
                  v-model="show"
                  @input="changeAccessType"
                  size="12px;"
                  active-color="#e4803c"
                  inactive-color="#dcdee0"
                /></div
            ></a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'set',
  data() {
    return {
      id: null,
      show: false,
      hallInfo: {
        id: null,
        accessType: null,
      }
    }
  },
  methods: {
    goto(str) {
      this.$router.push({ path: str })
    },
    changeAccessType(value){
      this.show = value
      if(this.show){
        this.hallInfo.accessType = 'public'
      } else {
        this.hallInfo.accessType = 'private'
      }
      this.updateHall()
    },
    queryHallInfo(){
      var that = this
      this.$queryOne(
        'HallInfo',
        {id: this.id, myId: this.$store.getters.userId},
        this.hallInfo,
        function(res) {
          if(res.code==1) {
            that.hallInfo.id = res.data.id
            that.hallInfo.accessType = that.$properties(res.data.accessType,'value')
            that.show = that.hallInfo.accessType == 'public' ? true : false
          }
        }
      )
    },
    updateHall() {
      var that = this
      this.hallInfo['myId'] = this.$store.getters.userId
      this.$submit('/api/hall/updateAccessType', this.hallInfo, function(res) {
        if (res.code === 1) {
          that.$toast("修改纪念馆成功！")
          that.queryHallInfo()
        }
      })
    },
  },
  created() {
    this.id = this.$route.params.id
    this.queryHallInfo()
  },
  watch: {},
}
</script>

<style>
.settingPage {
  padding: 0 15px;
}

.settingPage .setting-item {
  margin-top: 10px;
  background-color: #fff;
  line-height: 1.41176471;
  font-size: 1.3rem;
  overflow: hidden;
  position: relative;
}

.settingPage .setting-item .item-cell {
  padding: 15px;
  position: relative;
  display: flex;
  align-items: center;
}

.settingPage .setting-item .item-cell__bd {
  flex: 1;
  color: #333;
  font-size: 1.5rem;
}

.settingPage .setting-item .item-cell__ft {
  text-align: right;
  color: #999;
  position: relative;
  padding-right: 1.5rem;
}

.settingPage .setting-item .item-cell__ft.ft-line:after {
  content: ' ';
  display: inline-block;
  height: 11px;
  width: 7px;
  background: url(../../../assets/jnt/right.png);
  background-size: 100% 100%;
  position: absolute;
  top: 50%;
  margin-top: -5px;
  right: 2px;
}

.settingPage .setting-item .item-cell__ft .weui-switch-cp__input:checked ~ .weui-switch-cp__box,
.settingPage .setting-item .item-cell__ft .weui-switch:checked {
  border-color: #e4803c;
  background-color: #e4803c;
}

.settingPage .setting-item .item-cell .icon {
  display: inline-block;
  height: 24px;
  width: 24px;
  margin-right: 10px;
  margin-top: -3px;
}

.settingPage .setting-item .item-cell .icon-edit {
  background: url(../../../assets/jnt/note.png) no-repeat;
  background-size: 100% 100%;
}

.settingPage .setting-item .item-cell .icon-music {
  background: url(../../../assets/jnt/mp.png) no-repeat;
  background-size: 100% 100%;
}

.settingPage .setting-item .item-cell .icon-bg {
  background: url(../../../assets/jnt/tp.png) no-repeat;
  background-size: 100% 100%;
}

.settingPage .setting-item .item-cell .icon-photo {
  background: url(../../../assets/jnt/tp1.png) no-repeat;
  background-size: 100% 100%;
}
.settingPage .van-action-sheet__close {
  display: none;
}
.setting .content {
  color: rgb(177, 109, 78);
  position: relative;
  padding: 0;
  text-align: center;
  font-size: 1.3rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 4.2rem;
  display: flex;
}
.weui-cells {
  margin-top: 1.17647059em;
  background-color: #fff;
  line-height: 1.41176471;
  font-size: 17px;
  overflow: hidden;
  position: relative;
}
.weui-cell {
  padding: 15px;
  position: relative;
  display: flex;
  align-items: center;
}
.weui-cell__bd {
  flex: 1;
}
.text-center {
  text-align: center;
}
.weui-cells:after,
.weui-cells:before {
  content: ' ';
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  color: #e5e5e5;
}
.weui-cells:before {
  top: 0;
  border-top: 1px solid #e5e5e5;
  transform-origin: 0 0;
  transform: scaleY(0.5);
}
.weui-cells:after {
  bottom: 0;
  transform-origin: 0 100%;
  transform: scaleY(0.5);
}
.weui-cells:after,
.weui-cells:before {
  content: ' ';
  position: absolute;
  left: 0;
  right: 0;
  height: 1px;
  color: #e5e5e5;
}
.head-topbar.sticky {
  position: sticky;
  top: 0;
  left: 0;
  z-index: 100;
  width: 100%;
}
.head-topbar {
  display: flex;
  align-items: center;
  height: 3.8rem;
  background: #fff;
  position: fixed;
  width: 100%;
  z-index: 1;
}
.dashedlinebottom,
.dashedlinetop,
.linebottom,
.lineright,
.linetop {
  position: relative;
  -webkit-box-sizing: border-box;
  padding: 0;
}
.head-topbar .topbar-left {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 6.73333vw;
  position: absolute;
  left: 0.265rem;
  height: 100%;
  z-index: 10;
}

.head-topbar .topbar-left .icon-arrow-left {
  background: url(../../../assets/jnt/left1.png) no-repeat;
  background-size: 100%;
  display: inline-block;
  height: 1.363rem;
  width: 0.818rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.head-topbar .topbar-main {
  flex: 1;
  color: #333;
  font-size: 1.454rem;
}
h1,
h2,
h3,
h4,
h5,
h6 {
  font-size: 100%;
  font-weight: 400;
}
.head-topbar .topbar-right {
  padding-right: 1rem;
  position: absolute;
  right: 0.265rem;
  font-size: 1.272rem;
}
.head-topbar .topbar-main,
.head-topbar .topbar-right {
  display: flex;
  justify-content: center;
  align-items: center;
}
.settingPage .content {
  color: rgb(177, 109, 78);
  position: relative;
  padding: 0;
  text-align: center;
  font-size: 1.3rem;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  height: 4.2rem;
  display: flex;
}
</style>
